import axios from 'axios';

export const isExpectedAuthAxiosError = (error) => {
  if (!axios.isAxiosError(error) || error.response?.status !== 401) {
    return false;
  }
  const url = error.config?.url ?? '';
  return url.includes('token/refresh') || url.includes('/u/login');
};

export const captureAxiosError = (error) => {
  const data = error?.response?.data;
  const message =
    (typeof data === 'string' && data) ||
    data?.message ||
    data?.error ||
    error?.message ||
    'Error desconocido';
  throw new Error(message);
};
